import {browserRedirectMode} from './const/RedirectConst';
import React from 'react';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import VuCard from './vucard/VuCard';
import TransitionRedirectWrapper from './vucard/TransitionRedirectWrapper';
import SimpleRedirect from './vucard/SimpleRedirect';
import ClientAnalytics from './analytics/ClientAnalytics';
import {setupClientErrorReporting} from './utils/SentryUtils';
import {getCachedPreference} from './fingerprint/FingerprintRedirectPreferenceCache';
import RedirectPreferenceApi from './api/RedirectPreferenceApi';
import {getFingerprints} from './fingerprint/FingerprintUtils';
import {getRedirectCookie} from './utils/RedirectCookieUtils';
import {restoreScriptTags} from './utils/RenderUtils';

if (__PRODCLIENT__) {
  setupClientErrorReporting();
}

// Export React so the dev tools can find it
if (window === window.top) {
  window.React = React;
}

const vucardRoot = document.getElementById('vup-record-root');
if (vucardRoot) {
  ClientAnalytics.initialize();

  const state = restoreScriptTags(window.__STATE__);
  const {redirectParams} = state;
  const cardProps = _.omit(state, 'redirectParams');

  switch (state.redirectMode) {
    default:
      ReactDOM.hydrate(<VuCard {...state}/>, vucardRoot);
      break;
    case browserRedirectMode.transition: {
      ReactDOM.render(
        <TransitionRedirectWrapper {...redirectParams} cardProps={cardProps}/>, vucardRoot);
      break;
    }
    case browserRedirectMode.simple:
      ReactDOM.render(<SimpleRedirect {...redirectParams} cardProps={cardProps}/>, vucardRoot);
      break;
  }

  saveCookiePreferenceToFingerprintPreference();
}

async function saveCookiePreferenceToFingerprintPreference() {
  try {
    getFingerprints(async ({fingerprint, fingerprint2}) => {
      const cookiePreference = getRedirectCookie();
      const isCookiePreferenceEmpty = !cookiePreference || _.isEmpty(cookiePreference.campaigns);

      if (fingerprint2 && !isCookiePreferenceEmpty) {
        const fingerprintPreference = await getFingerprintPreference(fingerprint2, fingerprint);
        const isFingerprintPreferenceEmpty = !fingerprintPreference || _.isEmpty(fingerprintPreference.campaigns);
        if (isFingerprintPreferenceEmpty) {
          await RedirectPreferenceApi.set({fingerprint, fingerprint2}, cookiePreference);
        }
      }
    });
  } catch (e) {
    console.log(e);
  }
}

async function getFingerprintPreference(fingerprint2, fingerprintOld) {
  try {
    let fingerprintPreference = getCachedPreference();
    if (!fingerprintPreference) {
      fingerprintPreference = await RedirectPreferenceApi.get(fingerprint2, fingerprintOld);
    }
    return fingerprintPreference;
  } catch (e) {
    return null;
  }
}
